export const sanitizeTitle = (title) => {
    return title ? title.replace(/\//g, '') : '';
};
